import React, {useContext} from 'react';

import {FormattedMessage} from "react-intl";

import ArrowButton from "components/button/ArrowButton";

import SidebarHeadingTitle from "../SidebarHeadingTitle";
import ApplicationName from "./components/ApplicationName";
import SidebarFloatMenu from "../SidebarFloatMenu";

import {SidebarContext} from "../../../../SidebarContext";
import BottomDrawer from "../BottomDrawer";
import ApplicationMenuContent from "./components/ApplicationMenuContent";

function Applications(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const {organizationApplications, selectedApplication, isMobile} = useContext(SidebarContext);

    function handleClick(event){
        setAnchorEl(event.currentTarget);
    }

    if (!organizationApplications) {
        return null;
    }

    return (
        <div style={{
            paddingLeft: '12px',
            paddingRight: '12px'
        }}>
            <SidebarHeadingTitle>
               <FormattedMessage id='sidebar.application.title' />
            </SidebarHeadingTitle>
            <ArrowButton
                onClick={(e) => handleClick(e)}
                open={!!anchorEl}
                doubleArrow
            >
                <ApplicationName application={selectedApplication} selected={true} />
            </ArrowButton>
            {isMobile ? (
                <BottomDrawer
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    title={<FormattedMessage id='sidebar.application.menu.title' />}
                >
                    <ApplicationMenuContent />
                </BottomDrawer>
            ) : (
                <SidebarFloatMenu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    customMarginLeft={"0%"}
                    style={{ marginBottom: "8px"}}
                    anchorOrigin = {{vertical: 'top', horizontal: 'center'}}
                    transformOrigin = {{vertical: 'bottom', horizontal: 'left'}}
                >
                    <ApplicationMenuContent />
                </SidebarFloatMenu>
            )}
        </div>
    );
}

export default Applications;
